module.exports = __webpack_public_path__ + "img/type1.f17fae61.png";